import React from 'react';
import { Helmet } from "react-helmet";
import { DatePicker, Space } from 'antd';
import { PROJECTNAME } from '../constants/custom_config';
import Footer from './Footer';
import user_img from '../assets/images/user_img.png';
import search from '../assets/images/search.png';
import { Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';


import Headermain from './Headermain';
import Slidemenu from './Slidemenu';



class Account_settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        const menu = (
            <Menu
              items={[
                {
                  label: <div className="current-location-box">
                            <div className="current-location-title-area">
                                <div className="current-location-title-box">
                                    <p className="current-location-title">Current Location</p>
                                </div>
                            </div>
                            <div className="location-link-box">
                                <a href="" className="location-link">Detect Using GPS</a>
                            </div>
                        </div>
                ,
                  key: '0',
                },
                {
                  label: <div className="search-location-area">
                            <div className="search-location-box">
                                <input type="text" className="search-input-field common-input-field" placeholder="Search for location" />
                            </div>
                        </div>,
                  key: '1',
                }
              ]}
            />
          );
          
        function onChange(date, dateString) {
            console.log(date, dateString);
        }
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - My Profile</title>
                </Helmet>
                <Headermain prop={this.props} />
                <div className="content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="banner-dropdown-search-box-wrapper use-loaction-header profile-location-dropdown">
                                        <div className="banner-dropdown-search-area">
                                            <div className="banner-location-dropdown">
                                                <Dropdown overlay={menu} ClassName="location-dropdown" trigger={['click']} onClick={(e) => e.preventDefault()}>
                                                    <a onClick={(e) => e.preventDefault()}>
                                                    <Space>
                                                        Select Location
                                                        <DownOutlined />
                                                    </Space>
                                                    </a>
                                                </Dropdown>
                                            </div>
                                            <div className="banner-search-input-box" onClick={(e) => e.preventDefault()}>
                                                <span className="search-icon-box">
                                                    <img src={search} alt="" />
                                                </span>
                                                <input type="text" className="serach-input-field" placeholder="Search your Preferred Lab or Test" />
                                            </div>
                                        </div>
                                </div>
                                <Slidemenu  prop={this.props} />
                                <div className="account-settings common-content content">
                                    <h3>My Profile</h3>
                                    <div className="user-info">
                                        <div className="profile-pic">
                                            <img src={user_img} alt="John Doe" />
                                            <a href="" title="Change Photo">Change Photo</a>
                                            <input type="file" className="image-input"/>
                                        </div>
                                        <div className="profile-wrapper accordion" id="accordion">
                                            <div className="accordion-item">
                                                <span className="info-label">First Name</span>
                                                <div className="info-detail">
                                                    <span className="info-text">Vikash</span>
                                                    <a href="" title="Edit" className="accordion-button collapsed" id="heading1" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapseOne">
                                                        <span className="edit">Edit</span>
                                                        <span className="cancel">Cancel</span>
                                                    </a>
                                                    <div id="collapse1" className="accordion-collapse collapse" aria-labelledby="heading1" data-bs-parent="#accordion">
                                                        <div className="info-hide">
                                                            <input type="text" className="edit-text" name="name" value="Vikash" />
                                                            <a href="" title="Save" type="submit" className="save-btn">Save</a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <span className="info-label">Last Name</span>
                                                <div className="info-detail">
                                                    <span className="info-text">Gupta</span>
                                                    <a href="" className="accordion-button collapsed" title="Edit" id="heading2" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="true" aria-controls="collapseOne">
                                                        <span className="edit">Edit</span>
                                                        <span className="cancel">Cancel</span>
                                                    </a>
                                                    <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="heading2" data-bs-parent="#accordion">
                                                        <div className="info-hide">
                                                            <input type="text" className="edit-text" name="name" value="Gupta" />
                                                            <a href="" title="Save" type="submit" className="save-btn">Save</a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <span className="info-label">Mobile Number</span>
                                                <div className="info-detail">
                                                    <span className="info-text">+91 9898989898</span>
                                                    <a href="" className="accordion-button collapsed" title="Edit" id="heading4" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="true" aria-controls="collapseOne">
                                                        <span className="edit">Edit</span>
                                                        <span className="cancel">Cancel</span>
                                                    </a>
                                                    <div id="collapse4" className="accordion-collapse collapse" aria-labelledby="heading4" data-bs-parent="#accordion">
                                                        <div className="info-hide">
                                                            <input type="num" className="edit-text" name="number" value="+91 9898989898" />
                                                            <a href="" title="Save" type="submit" className="save-btn">Save</a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <span className="info-label">Email</span>
                                                <div className="info-detail">
                                                    <span className="info-text">vikash.gupta@gmail.com</span>
                                                    <a href="" className="accordion-button collapsed" title="Edit" id="heading3" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="true" aria-controls="collapseOne">
                                                        <span className="edit">Edit</span>
                                                        <span className="cancel">Cancel</span>
                                                    </a>
                                                    <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3" data-bs-parent="#accordion">
                                                        <div className="info-hide">
                                                            <input type="email" className="edit-text" name="email" value="vikash.gupta@gmail.com" />
                                                            <a href="" title="Save" type="submit" className="save-btn">Save</a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <span className="info-label">Gender</span>
                                                <div className="info-detail">
                                                    <span className="info-text">Male</span>
                                                    <a href="" className="accordion-button collapsed" title="Edit" id="heading5" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="true" aria-controls="collapseOne">
                                                        <span className="edit">Edit</span>
                                                        <span className="cancel">Cancel</span>
                                                    </a>
                                                    <div id="collapse5" className="accordion-collapse collapse" aria-labelledby="heading5" data-bs-parent="#accordion">
                                                        <div className="info-hide edit_form select-gender-field">
                                                            {/* <input type="text" className="edit-text" name="name" value="" />
                                                            <a href="" title="Save" type="submit" className="save-btn">Save</a> */}
                                                            
                                                            <div class="form-group radio accordion-radio-select">
                                                                <div class="gender-radio-select">
                                                                    <label class="radio-btn">Male
                                                                        <input type="radio" name="radio" id="billing"/>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <label class="radio-btn">Female
                                                                        <input type="radio" name="radio" id="shipping"/>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <a href="" title="Save" type="submit" className="save-btn">Save</a>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <span className="info-label">Date of Birth</span>
                                                <div className="info-detail">
                                                    <span className="info-text">24 Nov, 1985</span>
                                                    <a href="" className="accordion-button collapsed" title="Edit" id="heading7" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="true" aria-controls="collapseOne">
                                                        <span className="edit">Edit</span>
                                                        <span className="cancel">Cancel</span>
                                                    </a>
                                                    <div id="collapse7" className="accordion-collapse collapse" aria-labelledby="heading7" data-bs-parent="#accordion">
                                                        <div className="info-hide edit_form date-of-birth-field">
                                                            {/* <input type="text" className="edit-text" name="name" value="" /> */}
                                                            <Space direction="vertical" className="ant-space-custom form-group">
                                                                <DatePicker onChange={onChange} className="form-control date-picker-input"  dropdownClassName="date-picker-dropdown" format="DD MMMM,YYYY" placement="bottomLeft"/>
                                                            </Space>
                                                            <a href="" title="Save" type="submit" className="save-btn">Save</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer prop={this.props} />
            </>
        );
    }
};

export default Account_settings;